import { i18n } from 'i18n'

export const useLanguage = {
  changeLanguage: i18n.changeLanguage,
  language: i18n.language
}
